<section
    class="project-details-page"
    [attr.aria-busy]="busy !== null || settingsBusy !== null"
>
    <header class="page-heading">
        <h1>Proje detayları</h1>
        <nav aria-label="Gezinti">
            <button
                type="button"
                (click)="back.emit()"
            >
                Projeler</button
            ><span>/</span><span>{{ view?.name || 'Proje detayları' }}</span>
        </nav>
    </header>

    <ng-container *ngIf="view as p; else emptyState">
        <div
            *ngIf="isDeleted; else projectContent"
            class="deleted-state card-panel"
        >
            <span class="state-icon"
                ><i
                    class="bi bi-check-lg"
                    aria-hidden="true"
                ></i
            ></span>
            <h2>Proje silindi</h2>
            <p>Bu projenin bilgileri artık düzenlenemez.</p>
            <button
                type="button"
                class="action-button primary-button"
                (click)="back.emit()"
            >
                Projelere dön
            </button>
        </div>
        <ng-template #projectContent>
            <div class="details-layout">
                <div class="main-column">
                    <section
                        class="card-panel application-card"
                        aria-labelledby="applicationTitle"
                    >
                        <h2 id="applicationTitle">Bağlı uygulama</h2>
                        <div class="application-content">
                            <div class="application-logo">
                                <img
                                    *ngIf="
                                        p.applicationInfo?.logo && !logoFailed;
                                        else applicationFallback
                                    "
                                    [src]="p.applicationInfo?.logo"
                                    [alt]="p.applicationInfo?.name || 'Uygulama logosu'"
                                    (error)="logoFailed = true"
                                /><ng-template #applicationFallback
                                    ><i
                                        class="bi bi-box"
                                        aria-hidden="true"
                                    ></i
                                ></ng-template>
                            </div>
                            <div class="application-text">
                                <h3>
                                    {{ p.applicationInfo?.name || 'Uygulama bilgisi bulunamadı' }}
                                </h3>
                                <div class="application-tags">
                                    <span class="vendor-name">{{
                                        p.applicationInfo?.vendorName || '—'
                                    }}</span
                                    ><span class="tag">{{
                                        p.applicationInfo?.applicationTypeText ||
                                            'Tür belirtilmemiş'
                                    }}</span
                                    ><span class="tag">{{ p.applicationInfo?.version || '—' }}</span
                                    ><span class="tag">Uygulama PID: {{ p.applicationPid }}</span>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section class="card-panel project-heading">
                        <div class="project-identity">
                            <span
                                class="project-icon"
                                [style.color]="iconColor"
                                ><i
                                    [class]="iconClass"
                                    aria-hidden="true"
                                ></i
                            ></span>
                            <div>
                                <div class="project-title-row">
                                    <h2>{{ form.controls.name.value || p.name }}</h2>
                                    <span
                                        class="status-badge"
                                        [class.inactive]="!form.controls.isActive.value"
                                        ><span></span
                                        >{{
                                            form.controls.isActive.value ? 'Aktif' : 'Pasif'
                                        }}</span
                                    >
                                </div>
                                <p>
                                    Proje PID: {{ p.pid }} <span>·</span>
                                    {{ p.applicationInfo?.applicationTypeText || 'Proje' }}
                                </p>
                            </div>
                        </div>
                        <button
                            type="button"
                            class="favorite-button"
                            [class.selected]="form.controls.isFavorite.value"
                            [attr.aria-pressed]="form.controls.isFavorite.value"
                            [attr.aria-label]="
                                form.controls.isFavorite.value
                                    ? 'Favorilerden kaldır'
                                    : 'Favorilere ekle'
                            "
                            [disabled]="busy !== null || settingsBusy !== null"
                            (click)="toggleFavorite()"
                        >
                            <i
                                [class]="
                                    form.controls.isFavorite.value
                                        ? 'bi bi-star-fill'
                                        : 'bi bi-star'
                                "
                                aria-hidden="true"
                            ></i>
                        </button>
                    </section>

                    <div
                        class="project-tabs"
                        role="tablist"
                        aria-label="Proje detayları"
                    >
                        <button
                            *ngFor="let tab of tabs"
                            type="button"
                            role="tab"
                            [id]="'tab-' + tab.id"
                            [attr.aria-controls]="'panel-' + tab.id"
                            [attr.aria-selected]="currentTab === tab.id"
                            [class.active]="currentTab === tab.id"
                            [disabled]="settingsBusy !== null"
                            (click)="setTab(tab.id)"
                        >
                            <i
                                [class]="tab.icon"
                                aria-hidden="true"
                            ></i
                            >{{ tab.label }}
                        </button>
                    </div>

                    <form
                        [formGroup]="form"
                        (ngSubmit)="save()"
                        class="project-form"
                    >
                        <fieldset [disabled]="busy !== null || settingsBusy !== null">
                            <section
                                *ngIf="currentTab === 'general'"
                                id="panel-general"
                                role="tabpanel"
                                aria-labelledby="tab-general"
                                class="card-panel content-panel"
                            >
                                <div class="panel-heading">
                                    <h2>Proje bilgileri</h2>
                                    <p>Projenizin görünümünü ve temel bilgilerini düzenleyin.</p>
                                </div>
                                <div class="field">
                                    <label for="projectName"
                                        >Proje adı <span class="required">*</span></label
                                    ><input
                                        id="projectName"
                                        class="field-input"
                                        formControlName="name"
                                        maxlength="180"
                                        autocomplete="off"
                                        [class.invalid]="
                                            form.controls.name.touched && form.controls.name.invalid
                                        "
                                        aria-describedby="nameError"
                                    /><small
                                        id="nameError"
                                        class="field-error"
                                        *ngIf="
                                            form.controls.name.touched && form.controls.name.invalid
                                        "
                                        >Lütfen geçerli bir proje adı giriniz. En fazla 180 karakter
                                        kullanabilirsiniz.</small
                                    >
                                </div>
                                <div class="field">
                                    <label for="projectDescription">Açıklama</label
                                    ><textarea
                                        id="projectDescription"
                                        class="field-input"
                                        formControlName="description"
                                        rows="4"
                                        placeholder="Projenizi kısaca açıklayın"
                                    ></textarea>
                                </div>
                                <div class="field-grid">
                                    <div class="field">
                                        <label for="projectIcon">Proje ikonu</label>
                                        <div class="icon-input">
                                            <span [style.color]="iconColor"
                                                ><i
                                                    [class]="iconClass"
                                                    aria-hidden="true"
                                                ></i></span
                                            ><select
                                                id="projectIcon"
                                                class="field-input"
                                                formControlName="icon"
                                            >
                                                <option value="">İkon yok</option>
                                                <option
                                                    *ngFor="
                                                        let icon of iconOptions;
                                                        trackBy: trackValue
                                                    "
                                                    [value]="icon"
                                                >
                                                    {{ icon }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="field">
                                        <label for="projectColor">İkon rengi</label>
                                        <div class="color-input">
                                            <input
                                                type="color"
                                                [value]="iconColor"
                                                aria-label="İkon rengini seç"
                                                (input)="
                                                    form.controls.color.setValue(
                                                        $any($event.target).value
                                                    )
                                                "
                                            /><input
                                                id="projectColor"
                                                class="field-input"
                                                formControlName="color"
                                                placeholder="#1f6feb"
                                                maxlength="7"
                                                [class.invalid]="
                                                    form.controls.color.touched &&
                                                    form.controls.color.invalid
                                                "
                                            />
                                        </div>
                                        <small
                                            class="field-error"
                                            *ngIf="
                                                form.controls.color.touched &&
                                                form.controls.color.invalid
                                            "
                                            >Rengi #1f6feb formatında giriniz.</small
                                        >
                                    </div>
                                </div>
                                <div class="field-grid">
                                    <div class="field">
                                        <label for="projectActive">Proje durumu</label
                                        ><label
                                            class="switch-row"
                                            for="projectActive"
                                            ><input
                                                id="projectActive"
                                                type="checkbox"
                                                class="switch-input"
                                                role="switch"
                                                formControlName="isActive"
                                            /><span
                                                class="switch-track"
                                                aria-hidden="true"
                                            ></span
                                            ><span>{{
                                                form.controls.isActive.value ? 'Aktif' : 'Pasif'
                                            }}</span></label
                                        >
                                    </div>
                                    <div class="field">
                                        <label for="projectLanguage">Dil</label
                                        ><select
                                            id="projectLanguage"
                                            class="field-input"
                                            formControlName="lang"
                                        >
                                            <option
                                                *ngFor="
                                                    let language of languages;
                                                    trackBy: trackValue
                                                "
                                                [value]="language"
                                            >
                                                {{
                                                    language === 'tr'
                                                        ? 'Türkçe'
                                                        : language === 'en'
                                                          ? 'English'
                                                          : language
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="field last-field">
                                    <label for="coverImage"
                                        >Kapak görseli bağlantısı
                                        <span class="optional">(isteğe bağlı)</span></label
                                    ><input
                                        id="coverImage"
                                        class="field-input"
                                        formControlName="coverImageUrl"
                                        placeholder="https://... veya /assets/..."
                                    /><small class="field-hint"
                                        >Proje kartında kullanılacak görselin bağlantısı.</small
                                    >
                                </div>
                            </section>

                            <section
                                *ngIf="currentTab === 'access'"
                                id="panel-access"
                                role="tabpanel"
                                aria-labelledby="tab-access"
                                class="card-panel content-panel"
                            >
                                <div class="panel-heading">
                                    <h2>Erişim ayarları</h2>
                                    <p>
                                        İzin verilen alan adlarını düzenleyin ve veri erişim
                                        anahtarınızı görüntüleyin.
                                    </p>
                                </div>
                                       <div class="field">
                                    <label for="dataAccessDomain">Projeye erişim adresi</label>
                                    <div class="token-row">
                                        <input
                                            id="dataAccessDomain"
                                            class="field-input token-input"
                                            [type]="showAddress ? 'password' : 'text'"
                                            [value]="p.dataAccessDomain"
                                            readonly
                                            autocomplete="off"
                                            spellcheck="false"
                                            placeholder="Anahtar bulunamadı"
                                        /><button
                                            type="button"
                                            class="square-button"
                                            (click)="showAddress = !showAddress"
                                            [disabled]="!p.dataAccessDomain"
                                            [attr.aria-label]="
                                                showAddress ? 'Anahtarı gizle' : 'Anahtarı göster'
                                            "
                                        >
                                            <i
                                                [class]="
                                                    showAddress ? 'bi bi-eye' : 'bi bi-eye-slash'
                                                "
                                                aria-hidden="true"
                                            ></i></button
                                        ><button
                                            type="button"
                                            class="square-button"
                                            [disabled]="!p.dataAccessDomain"
                                            (click)="copy(p.dataAccessDomain)"
                                            aria-label="Erişim adresini kopyala"
                                        >
                                            <i
                                                class="bi bi-copy"
                                                aria-hidden="true"
                                            ></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="field">
                                    <label for="accessToken">Veri erişim anahtarı</label>
                                    <div class="token-row">
                                        <input
                                            id="accessToken"
                                            class="field-input token-input"
                                            [type]="showToken ? 'password' : 'text'"
                                            [value]="p.dataAccessToken || ''"
                                            readonly
                                            autocomplete="off"
                                            spellcheck="false"
                                            placeholder="Anahtar bulunamadı"
                                        /><button
                                            type="button"
                                            class="square-button"
                                            (click)="showToken = !showToken"
                                            [disabled]="!p.dataAccessToken"
                                            [attr.aria-label]="
                                                showToken ? 'Anahtarı gizle' : 'Anahtarı göster'
                                            "
                                        >
                                            <i
                                                [class]="
                                                    showToken ? 'bi bi-eye' : 'bi bi-eye-slash'
                                                "
                                                aria-hidden="true"
                                            ></i></button
                                        ><button
                                            type="button"
                                            class="square-button"
                                            [disabled]="!p.dataAccessToken"
                                            (click)="copy(p.dataAccessToken)"
                                            aria-label="Erişim anahtarını kopyala"
                                        >
                                            <i
                                                class="bi bi-copy"
                                                aria-hidden="true"
                                            ></i>
                                        </button>
                                    </div>
                                </div>
                                <div class="info-note">
                                    <i
                                        class="bi bi-info-circle"
                                        aria-hidden="true"
                                    ></i
                                    ><span
                                        >Alan adı değişikliklerini uygulamak için Kaydet butonunu
                                        kullanın.</span
                                    >
                                </div>
                            </section>

                            <section
                                *ngIf="currentTab === 'usage'"
                                id="panel-usage"
                                role="tabpanel"
                                aria-labelledby="tab-usage"
                                class="card-panel content-panel"
                            >
                                <div class="panel-heading">
                                    <h2>Kullanım ve istatistikler</h2>
                                    <p>
                                        Abonelik ve kullanım verileri sunucudan gelen değerlerle
                                        gösterilir.
                                    </p>
                                </div>
                                <div class="usage-progress-heading">
                                    <strong
                                        >{{ number(p.usageModel?.current) }} /
                                        {{ p.usageModel ? number(p.usageModel.max) : '—' }}</strong
                                    ><span>Kullanım</span>
                                </div>
                                <div
                                    class="usage-progress"
                                    role="progressbar"
                                    [attr.aria-valuenow]="usagePercent"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                    aria-label="Kullanım oranı"
                                >
                                    <span [style.width.%]="usagePercent"></span>
                                </div>
                                <dl class="detail-list">
                                    <div>
                                        <dt>Abonelik başlangıcı</dt>
                                        <dd>{{ dateText(p.usageModel?.subscriptionBeginDate) }}</dd>
                                    </div>
                                    <div>
                                        <dt>Abonelik bitişi</dt>
                                        <dd>{{ dateText(p.usageModel?.subscriptionEndDate) }}</dd>
                                    </div>
                                    <div>
                                        <dt>Kullanım kullanıcı PID (userPid)</dt>
                                        <dd>{{ p.usageModel?.userPid ?? '—' }}</dd>
                                    </div>
                                    <div>
                                        <dt>Kullanım tür kodu (usageType)</dt>
                                        <dd>{{ p.usageModel?.usageType ?? '—' }}</dd>
                                    </div>
                                    <div>
                                        <dt>Toplam istek</dt>
                                        <dd>{{ number(p.totalRequestNumber) }}</dd>
                                    </div>
                                    <div>
                                        <dt>Hatalı istek</dt>
                                        <dd>{{ number(p.totalRequestError) }}</dd>
                                    </div>
                                    <div>
                                        <dt>Aktarılan veri</dt>
                                        <dd>
                                            {{ bytes(p.totalRequestByte) }}
                                            <span class="sub-value"
                                                >({{ number(p.totalRequestByte) }} bayt)</span
                                            >
                                        </dd>
                                    </div>
                                    <div>
                                        <dt>Son kullanım</dt>
                                        <dd>
                                            {{ dateText(p.finalUsageDate, 'Henüz kullanılmadı') }}
                                        </dd>
                                    </div>
                                    <div>
                                        <dt>Proje bitişi</dt>
                                        <dd>{{ dateText(p.projectEndDate, 'Belirtilmemiş') }}</dd>
                                    </div>
                                </dl>
                            </section>

                            <section
                                *ngIf="currentTab === 'technical'"
                                id="panel-technical"
                                role="tabpanel"
                                aria-labelledby="tab-technical"
                                class="card-panel content-panel"
                            >
                                <div class="panel-heading">
                                    <h2>Teknik bilgiler</h2>
                                    <p>Kimlik, sistem ve bağlı uygulama bilgileri.</p>
                                </div>
                                <dl class="detail-list technical-list">
                                    <div *ngFor="let row of generalRows; trackBy: trackRow">
                                        <dt>{{ row.label }}</dt>
                                        <dd>{{ row.value || '—' }}</dd>
                                    </div>
                                </dl>
                                <h3 class="subheading">Bağlı uygulama bilgileri</h3>
                                <dl class="detail-list technical-list">
                                    <div *ngFor="let row of applicationRows; trackBy: trackRow">
                                        <dt>{{ row.label }}</dt>
                                        <dd>{{ row.value || '—' }}</dd>
                                    </div>
                                </dl>
                            </section>
                            <section *ngIf="currentTab === 'location'" id="panel-location" role="tabpanel" aria-labelledby="tab-location" class="card-panel content-panel settings-panel">
                                <div class="settings-panel-heading"><div class="settings-heading-icon"><i class="bi bi-geo-alt" aria-hidden="true"></i></div><div><span class="settings-eyebrow">PROJE KONUMU</span><h2>Lokasyon</h2><p>IP adresinden konum bulun veya haritadan bir nokta seçin.</p></div><span class="settings-state" [class.pending]="locationDirty">{{ locationDirty ? 'Kaydedilmedi' : 'Proje lokasyonu' }}</span></div>
                               
                                 <div class="settings-input-card">
                                    <label for="projectLocationIp">IP Adresin</label>
                                    <div class="settings-input-row"><div class="settings-input-wrap">
                                        <i class="bi bi-hdd-network" aria-hidden="true"></i>
                                        <input id="projectLocationIp" class="field-input"  [readonly]="true" maxlength="45" [value]="project?.ip" autocomplete="off" spellcheck="false" aria-describedby="locationIpHelp" />
                                    </div>
                                    
                                  </div>
                                </div>
                               
                                <div class="settings-input-card">
                                    <label for="projectLocationIp">Proje IP Adresi</label>
                                    <div class="settings-input-row"><div class="settings-input-wrap">
                                        <i class="bi bi-hdd-network" aria-hidden="true"></i>
                                        <input id="projectLocationIp" class="field-input" [formControl]="ipControl" [readonly]="!ipEditing || settingsLocked" maxlength="45" autocomplete="off" spellcheck="false" placeholder="Örn. 8.8.8.8 veya IPv6 adresi" (keydown.enter)="$event.preventDefault(); checkLocationIp()" aria-describedby="locationIpHelp" />
                                    </div>
                                    
                                    <button type="button" class="settings-edit-button" role="switch" [attr.aria-checked]="ipEditing" [class.is-editing]="ipEditing" [disabled]="settingsLocked" (click)="toggleIpEditing()" title="IP düzenlemeyi aç/kapat"><i class="bi" [class.bi-pencil-square]="!ipEditing" [class.bi-lock]="ipEditing" aria-hidden="true"></i>
                                        <span>Edit</span><span class="settings-toggle" aria-hidden="true"></span></button><button type="button" class="action-button primary-button settings-confirm-button" [disabled]="settingsLocked || !ipControl.value.trim()" (click)="checkLocationIp()"><span *ngIf="settingsBusy === 'lookup'" class="loading-spinner" aria-hidden="true"></span><i *ngIf="settingsBusy !== 'lookup'" class="bi bi-search" aria-hidden="true"></i>{{ settingsBusy === 'lookup' ? 'Kontrol ediliyor…' : 'Kontrol' }}</button></div>
                                    <small id="locationIpHelp">Düzenlemek için Edit anahtarını açın. Kontrol, IP bilgisini API üzerinden sorgular.</small>
                                </div>
                                <div *ngIf="locationFeedback as result" class="settings-feedback" [class.is-error]="result.type === 'error'" role="status"><i class="bi" [class.bi-exclamation-circle]="result.type === 'error'" [class.bi-check-circle]="result.type === 'success'" aria-hidden="true"></i>{{ result.message }}</div>
                                <div class="settings-map-shell" [class.is-busy]="settingsLocked">
                                    <ng-template #locationMapHost></ng-template>
                                </div>
                                <div class="settings-details-heading"><h3>Lokasyon bilgileri</h3><button type="button" class="text-button" [disabled]="settingsLocked || locationDirty" (click)="loadLocation()"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Yenile</button></div>
                                <dl class="location-details-grid"><div *ngFor="let row of locationRows; trackBy: trackRow"><dt>{{ row.label }}</dt><dd>{{ row.value || '—' }}</dd></div></dl>
                                <p class="settings-footnote"><i class="bi bi-info-circle" aria-hidden="true"></i>Harita offline çalışır. IP kontrolü ve saklama için API bağlantısı gerekir. Yerel dünya haritası sokak ve bina ayrıntısı içermez.</p>
                            </section>

                            <section *ngIf="currentTab === 'notifications'" id="panel-notifications" role="tabpanel" aria-labelledby="tab-notifications" class="card-panel content-panel settings-panel">
                                <div class="settings-panel-heading"><div class="settings-heading-icon"><i class="bi bi-bell" aria-hidden="true"></i></div><div><span class="settings-eyebrow">İLETİŞİM TERCİHLERİ</span><h2>Bildirimler</h2><p>Proje bildirimlerinin iletileceği e-posta ve telefon numarasını yönetin.</p></div></div>
                                <div class="notification-intro"><span><i class="bi bi-shield-check" aria-hidden="true"></i></span><div><strong>Bildirim iletişim bilgileri</strong><p>Her alanı ayrı ayrı düzenleyip Onayla butonuyla kaydedebilirsiniz.</p></div><button type="button" class="text-button" [disabled]="settingsLocked || emailEditing || phoneEditing" (click)="loadNotifications()"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Yenile</button></div>
                                <div *ngIf="notificationFeedback as result" class="settings-feedback" [class.is-error]="result.type === 'error'" role="status"><i class="bi" [class.bi-exclamation-circle]="result.type === 'error'" [class.bi-check-circle]="result.type === 'success'" aria-hidden="true"></i>{{ result.message }}</div>
                                <div class="notification-field-card">
                                    <div class="notification-field-heading"><span><i class="bi bi-envelope" aria-hidden="true"></i></span><div><label for="projectNotificationEmail">Bildirim e-posta adresi</label><p>Bildirimlerin gönderileceği e-posta adresi.</p></div><span class="notification-field-status" [class.editing]="emailEditing">{{ emailEditing ? 'Düzenleniyor' : 'Salt okunur' }}</span></div>
                                    <div class="settings-input-row"><input id="projectNotificationEmail" class="field-input" type="email" [formControl]="notificationEmailControl" [readonly]="!emailEditing || settingsLocked" [class.invalid]="emailEditing && notificationEmailControl.touched && notificationEmailControl.invalid" maxlength="180" autocomplete="email" placeholder="bildirim@sirketiniz.com" (keydown.enter)="$event.preventDefault(); saveNotification('Email')" aria-describedby="notificationEmailError" /><button type="button" class="settings-edit-button" role="switch" [attr.aria-checked]="emailEditing" [class.is-editing]="emailEditing" [disabled]="settingsLocked" (click)="toggleNotificationEditing('Email')"><i class="bi bi-pencil-square" aria-hidden="true"></i><span>Edit</span><span class="settings-toggle" aria-hidden="true"></span></button><button type="button" class="action-button primary-button settings-confirm-button" [disabled]="settingsLocked || !emailEditing" (click)="saveNotification('Email')"><span *ngIf="settingsBusy === 'email'" class="loading-spinner" aria-hidden="true"></span><i *ngIf="settingsBusy !== 'email'" class="bi bi-check2" aria-hidden="true"></i>{{ settingsBusy === 'email' ? 'Kaydediliyor…' : 'Onayla' }}</button></div>
                                    <small id="notificationEmailError" class="field-error" *ngIf="emailEditing && notificationEmailControl.touched && notificationEmailControl.invalid">Geçerli bir e-posta adresi giriniz.</small>
                                </div>
                                <div class="notification-field-card">
                                    <div class="notification-field-heading"><span><i class="bi bi-telephone" aria-hidden="true"></i></span><div><label for="projectNotificationPhone">Bildirim telefon numarası</label><p>Ülke koduyla birlikte telefon numaranız.</p></div><span class="notification-field-status" [class.editing]="phoneEditing">{{ phoneEditing ? 'Düzenleniyor' : 'Salt okunur' }}</span></div>
                                    <div class="settings-input-row"><input id="projectNotificationPhone" class="field-input" type="tel" [formControl]="notificationPhoneControl" [readonly]="!phoneEditing || settingsLocked" [class.invalid]="phoneEditing && notificationPhoneControl.touched && notificationPhoneControl.invalid" maxlength="25" autocomplete="tel" placeholder="+90 5XX XXX XX XX" (keydown.enter)="$event.preventDefault(); saveNotification('Phone')" aria-describedby="notificationPhoneError" /><button type="button" class="settings-edit-button" role="switch" [attr.aria-checked]="phoneEditing" [class.is-editing]="phoneEditing" [disabled]="settingsLocked" (click)="toggleNotificationEditing('Phone')"><i class="bi bi-pencil-square" aria-hidden="true"></i><span>Edit</span><span class="settings-toggle" aria-hidden="true"></span></button><button type="button" class="action-button primary-button settings-confirm-button" [disabled]="settingsLocked || !phoneEditing" (click)="saveNotification('Phone')"><span *ngIf="settingsBusy === 'phone'" class="loading-spinner" aria-hidden="true"></span><i *ngIf="settingsBusy !== 'phone'" class="bi bi-check2" aria-hidden="true"></i>{{ settingsBusy === 'phone' ? 'Kaydediliyor…' : 'Onayla' }}</button></div>
                                    <small id="notificationPhoneError" class="field-error" *ngIf="phoneEditing && notificationPhoneControl.touched && notificationPhoneControl.invalid">Geçerli bir telefon numarası giriniz.</small>
                                </div>
                                <p class="settings-footnote"><i class="bi bi-info-circle" aria-hidden="true"></i>Edit anahtarı kapatılırsa kaydedilmemiş alan eski değerine döner. Onayla, ilgili alanı API üzerinden kaydeder.</p>
                            </section>

                        </fieldset>
                    </form>
                    <p class="project-metadata">
                        <span>Proje PID: {{ p.pid }}</span
                        ><span>Oluşturulma: {{ shortDate(p.createdDate) }}</span
                        ><span
                            >Son kullanım:
                            {{ dateText(p.finalUsageDate, 'Henüz kullanılmadı') }}</span
                        >
                    </p>
                </div>

                <aside
                    class="sidebar-column"
                    aria-label="Proje özeti"
                >
                    <section class="card-panel usage-card">
                        <h2>Kullanım özeti</h2>
                        <div class="usage-overview">
                            <div
                                class="usage-ring"
                                [style.--usage-angle]="usagePercent * 3.6 + 'deg'"
                            >
                                <div>
                                    <i
                                        class="bi bi-pie-chart"
                                        aria-hidden="true"
                                    ></i
                                    ><strong
                                        >{{ number(p.usageModel?.current) }} /
                                        {{ p.usageModel ? number(p.usageModel.max) : '—' }}</strong
                                    ><span>Kullanım</span>
                                </div>
                            </div>
                            <div class="subscription-dates">
                                <div>
                                    <i
                                        class="bi bi-calendar-check"
                                        aria-hidden="true"
                                    ></i
                                    ><span
                                        >Abonelik başlangıcı<strong>{{
                                            shortDate(p.usageModel?.subscriptionBeginDate)
                                        }}</strong></span
                                    >
                                </div>
                                <div>
                                    <i
                                        class="bi bi-calendar-event"
                                        aria-hidden="true"
                                    ></i
                                    ><span
                                        >Abonelik bitişi<strong>{{
                                            shortDate(p.usageModel?.subscriptionEndDate)
                                        }}</strong></span
                                    >
                                </div>
                            </div>
                        </div>
                        <div class="usage-stats">
                            <div>
                                <i
                                    class="bi bi-database"
                                    aria-hidden="true"
                                ></i
                                ><span>Toplam istek</span
                                ><strong>{{ number(p.totalRequestNumber) }}</strong>
                            </div>
                            <div class="error-stat">
                                <i
                                    class="bi bi-exclamation-triangle"
                                    aria-hidden="true"
                                ></i
                                ><span>Hatalı istek</span
                                ><strong>{{ number(p.totalRequestError) }}</strong>
                            </div>
                            <div>
                                <i
                                    class="bi bi-arrow-left-right"
                                    aria-hidden="true"
                                ></i
                                ><span>Aktarılan veri</span
                                ><strong>{{ bytes(p.totalRequestByte) }}</strong>
                            </div>
                        </div>
                    </section>

              
                    <section class="card-panel summary-card">
                        <div class="summary-heading">
                            <h2>Teknik bilgiler</h2>
                            <button
                                type="button"
                                class="text-button"
                                (click)="setTab('technical')"
                            >
                                Tümü<i
                                    class="bi bi-arrow-up-right"
                                    aria-hidden="true"
                                ></i>
                            </button>
                        </div>
                        <dl class="summary-list">
                            <div>
                                <dt>Proje anahtarı</dt>
                                <dd class="key-value">
                                    <code [title]="p.projectKey">{{ p.projectKey || '—' }}</code
                                    ><button
                                        type="button"
                                        class="square-button"
                                        [disabled]="!p.projectKey || busy !== null"
                                        (click)="copy(p.projectKey)"
                                        aria-label="Proje anahtarını kopyala"
                                    >
                                        <i
                                            class="bi bi-copy"
                                            aria-hidden="true"
                                        ></i>
                                    </button>
                                </dd>
                            </div>
                            <div>
                                <dt>Son veri IP</dt>
                                <dd>{{ p.lastDataIP || '—' }}</dd>
                            </div>
                            <div>
                                <dt>Son veri tarihi</dt>
                                <dd>{{ dateText(p.lastIncommingDataDate) }}</dd>
                            </div>
                        </dl>
                    </section>
                </aside>
            </div>

            <footer class="action-bar">
                <button
                    type="button"
                    class="action-button delete-button"
                    [disabled]="busy !== null || settingsBusy !== null"
                    (click)="openDelete($event)"
                >
                    <i
                        class="bi bi-trash3"
                        aria-hidden="true"
                    ></i
                    >Sil
                </button>
                <div class="right-actions">
                    <span
                        class="unsaved-note"
                        *ngIf="dirty"
                        >Kaydedilmemiş değişiklikler var</span
                    ><button
                        type="button"
                        class="action-button secondary-button"
                        [disabled]="busy !== null || settingsBusy !== null || !dirty"
                        (click)="reset()"
                    >
                        Sıfırla</button
                    ><button
                        type="button"
                        class="action-button primary-button"
                        [disabled]="busy !== null || settingsBusy !== null || !dirty"
                        (click)="save()"
                    >
                        <span
                            *ngIf="busy === 'save'"
                            class="loading-spinner"
                            aria-hidden="true"
                        ></span
                        >{{ busy === 'save' ? 'Kaydediliyor…' : 'Kaydet' }}
                    </button>
                </div>
            </footer>
        </ng-template>
    </ng-container>

    <ng-template #emptyState
        ><div class="empty-state card-panel">
            <i
                class="bi bi-folder2-open"
                aria-hidden="true"
            ></i>
            <h2>Proje seçilmedi</h2>
            <p>Proje detaylarını görüntülemek için bir proje seçin.</p>
        </div></ng-template
    >
    <div
        #feedbackPanel
        class="feedback-slot"
        aria-live="polite"
        aria-atomic="true"
    >
        <div
            *ngIf="feedback as result"
            class="feedback-panel"
            [class.feedback-success]="result.type === 'success'"
            [class.feedback-error]="result.type === 'error'"
            [attr.role]="result.type === 'error' ? 'alert' : 'status'"
        >
            <i
                [class]="
                    result.type === 'success'
                        ? 'bi bi-check-circle-fill'
                        : 'bi bi-exclamation-circle-fill'
                "
                aria-hidden="true"
            ></i>
            <p>{{ result.message }}</p>
            <button
                type="button"
                (click)="feedback = null"
                aria-label="Bildirimi kapat"
            >
                <i
                    class="bi bi-x-lg"
                    aria-hidden="true"
                ></i>
            </button>
        </div>
    </div>
</section>

<dialog
    #deleteDialog
    class="delete-dialog"
    aria-labelledby="deleteTitle"
    aria-describedby="deleteDescription"
    (cancel)="onDialogCancel($event)"
    (close)="onDialogClosed()"
    (keydown)="trapDialogFocus($event)"
>
    <form (submit)="$event.preventDefault(); confirmDelete()">
        <div class="delete-modal-icon">
            <i
                class="bi bi-trash3"
                aria-hidden="true"
            ></i>
        </div>
        <h2 id="deleteTitle">Projeyi sil</h2>
        <p id="deleteDescription">
            Bu işlem geri alınamaz. Onaylamak için projenin adını aşağıya yazın.
        </p>
        <label for="deleteProjectName"
            >Proje adı: <strong>{{ view?.name }}</strong></label
        ><input
            #deleteInput
            id="deleteProjectName"
            class="field-input"
            [formControl]="deleteNameControl"
            [class.invalid]="!!deleteError"
            [attr.aria-invalid]="!!deleteError"
            aria-describedby="deleteError"
            placeholder="Proje adını giriniz"
            autocomplete="off"
            autofocus
        />
        <p
            id="deleteError"
            class="delete-validation"
            *ngIf="deleteError"
        >
            <i
                class="bi bi-exclamation-circle-fill"
                aria-hidden="true"
            ></i
            >{{ deleteError }}
        </p>
        <div class="delete-modal-actions">
            <button
                type="button"
                class="action-button secondary-button"
                [disabled]="busy === 'delete'"
                (click)="closeDelete()"
            >
                Vazgeç</button
            ><button
                type="submit"
                class="action-button primary-button"
                [disabled]="busy === 'delete'"
            >
                <span
                    *ngIf="busy === 'delete'"
                    class="loading-spinner"
                    aria-hidden="true"
                ></span
                >{{ busy === 'delete' ? 'Siliniyor…' : 'Sil' }}
            </button>
        </div>
    </form>
</dialog>
